<template>
  <div class="uploadWrapper" :class="theme">
    <el-upload
      :action="fileUploadUrl"
      :headers="''|getHttpHeader"
      :before-upload="beforeUpload"
      :on-success="fileUploadSuccess"
      :show-file-list="false"
      name="attachment"
      :accept="fileAccept"
      class="uploadEl"
    >
    <el-button size="mini" :loading="loading" type="primary">{{!value ? $t('portal.ben-di-shang-chuan') : $t('portal.geng-gai') }}</el-button>

    </el-upload>
    <div v-if="theme === 'downTheme' && value" class="downArea">
      <div class="nameArea" v-if="fileName">
        <i class="el-icon-document"></i>
        <span :title="fileName"  class="fileName">{{fileName}}</span>
        <div class="delete" @click="deleteAction">{{ $t('button.delete') }}</div>
      </div>
    </div>
     <div v-else-if="value" class="fileArea">
      <div v-if="fileType === 'file'" class="fileWrapper">
        <img class="attachment-icon-img" :src="value|getFileTypeIcon('m')" :title="value.file_name" />
        <span :title="fileName" v-if="fileName" class="fileName">{{fileName}}</span>
      </div>
      <div v-else class="attachment-icon">
        <i class="el-icon-paperclip" :title="value"></i>
        <span>{{value}}</span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 附件上传按钮组件
 * 能实现v-model双向数据绑定
 * 支持返回{ ipfs, file_name }和ipfs
 */

// 目前项目中使用到的只罗列这么多，待完善
const acceptObj = {
  csv: '.csv',
  xls: 'application/vnd.ms-excel application/x-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
};
export default {
  props: {
    // 编辑时对应ipfs或file
    value: {
      type: [String, Object]
    },
    // 接收类型，file|url|ipfs  默认返回{ ipfs, file_name }，或拼接好的url，否则仅为ipfs
    fileType: {
      type: String,
      default: 'file'
    },
    // 示例 csv/xls/xlsx/pdf
    accept: {
      type: String,
      default: ''
    },
    fileSize: {
      type: Number,
      default: 50000000
    },
    message: {
      type: String,
      default: 'portal.attachment_large'
    },
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    fileAccept() {
      const {
        accept
      } = this;
      if (accept === '') {
        return '*.*';
      }
      return accept.split('/').map(fileExt => {
        return acceptObj[fileExt] || `.${fileExt}`;
      }).join(',');
    }
  },
  data() {
    return {
      fileUploadUrl: '/rest/erp/general/v3/upload',
      ipfsPrefix: '/rest/store/general/v3/image/',
      // 上传的文件大小
      uploadFileSize: 0,
      fileName: '',
      loading: false
    };
  },
  methods: {
    fileUploadSuccess({
      data
    }) {
      let newVal = data.ipfs;
      if (this.fileType === 'file') {
        newVal = data;
      } else if (this.fileType === 'url') {
        newVal = `${this.ipfsPrefix}${data.ipfs}`;
      }
      this.fileName = data.file_name;
      this.$emit('input', newVal);
      this.$emit('uploaded', {
        ...data,
        size: this.uploadFileSize
      });
      this.loading = false;
    },
    beforeUpload(file) {
      this.loading = true;
      const {
        accept,
        fileSize
      } = this;
      const fileExt = file.name.split('.').length > 1 ? file.name.split('.').slice(-1)[0] : '';
      if (file.size > fileSize || accept !== '' && accept.indexOf(fileExt) < 0 || fileExt === '') {
        this.$message({
          message: this.message,
          type: 'error'
        });
        this.loading = false;
        return false;
      }
      // 暂存文件大小
      this.uploadFileSize = file.size;
      return true;
    },
    deleteAction() {
      this.$emit('input', '');
    }
  }
};
</script>

<style lang="less" scoped>
.uploadWrapper{
  display: flex;
  align-items: center;
  /deep/ .el-upload{
            display: flex;
            width: 100%;
            overflow: hidden;
          }
  &.downTheme{
    flex-direction: column;
    align-items: flex-start;
    .nameArea{
      display: flex;
      align-items: center;
      .fileName{
        padding-left: 5px;
      }
      .delete{
        color: @icColor;
        cursor: pointer;
        padding-left: 10px;
      }
    }
  }
}
.fileArea{
  flex: 1;
  display: flex;
  min-width: 0;
}
.fileWrapper{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  min-width: 0;
  .fileName{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
.attachment-icon-img {
  max-width: 30px;
  max-height: 30px;
  display: block;
}
.attachment-icon {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  & > i {
    font-size: 20px;
  }
  & > span {
    display: inline-block;
    width: 70%;
    height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
